(function() {
	document.addEventListener('DOMContentLoaded', function() {
		var copyLink = document.getElementById('copyLink');
		copyLink.addEventListener('click', function(event) {
			event.preventDefault(); // Prevent the default action of anchor tag
			const url = window.location.origin + copyLink.previousElementSibling.getAttribute('href'); // Get the URL from href attribute
			copyToClipboard(url); // Call the function to copy to clipboard
		});

		const copyToClipboard = (text) => {
			navigator.clipboard.writeText(text).then(() => {
				alert('URL copied to clipboard!');
			}).catch(error => console.error('Failed to copy: ', error));
		};
	});
})();
